var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "query-form",
          attrs: { size: "small", inline: true, model: _vm.searchForm },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.refreshList()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "categoryId" } },
            [
              _c("SelectTree", {
                ref: "category",
                attrs: {
                  props: {
                    value: "id", // ID字段名
                    label: "name", // 显示名称
                    children: "children", // 子级字段名
                  },
                  placeholder: "请选择大屏分类",
                  size: "small",
                  url: "/datav/dataScreenCategory/treeData",
                  value: _vm.searchForm.categoryId,
                  clearable: true,
                  accordion: true,
                },
                on: {
                  getValue: function (value) {
                    _vm.searchForm.categoryId = value
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "name" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  placeholder: "大屏名称",
                  clearable: "",
                },
                model: {
                  value: _vm.searchForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "name", $$v)
                  },
                  expression: "searchForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh-right" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white top", staticStyle: { padding: "0px" } },
        [
          _vm._v(" `"),
          _c(
            "div",
            {
              staticClass: "el-scrollbar__wrap",
              staticStyle: { padding: "10px", height: "calc(100% - 70px)" },
            },
            [
              _c(
                "div",
                { staticClass: "el-scrollbar__view" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticStyle: { margin: "8px" },
                              attrs: {
                                "body-style": { padding: "0px" },
                                shadow: "always",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "jp-card jp-card-bordered" },
                                [
                                  _c("div", { staticClass: "add-border" }, [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.add()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-plus",
                                        }),
                                        _c("p", [_vm._v("新建大屏")]),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.dataList, function (datascreen, index) {
                        return _c(
                          "el-col",
                          {
                            key: index,
                            attrs: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
                          },
                          [
                            _c(
                              "el-card",
                              {
                                staticStyle: { margin: "8px" },
                                attrs: {
                                  "body-style": { padding: "0px" },
                                  shadow: "always",
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "image",
                                  attrs: { src: datascreen.screenShot },
                                }),
                                _c(
                                  "h3",
                                  { staticClass: "jp-card-label" },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 16 } }, [
                                          _c("div", { staticClass: "left" }, [
                                            _vm._v(_vm._s(datascreen.name)),
                                          ]),
                                        ]),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-link",
                                              {
                                                staticClass:
                                                  "el-icon-edit-outline right",
                                                attrs: { underline: false },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.design(
                                                      datascreen.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 设计")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("ul", { staticClass: "jp-card-actions" }, [
                                  _c(
                                    "li",
                                    { staticStyle: { width: "25%" } },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { underline: false },
                                          on: {
                                            click: function ($event) {
                                              return _vm.edit(datascreen.id)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit-outline",
                                          }),
                                          _vm._v(" 编辑"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "li",
                                    { staticStyle: { width: "25%" } },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { underline: false },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copy(datascreen.id)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-document-copy",
                                          }),
                                          _vm._v(" 复制"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "li",
                                    { staticStyle: { width: "25%" } },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { underline: false },
                                          on: {
                                            click: function ($event) {
                                              return _vm.del(datascreen.id)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                          _vm._v(" 删除"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "li",
                                    { staticStyle: { width: "25%" } },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { underline: false },
                                          on: {
                                            click: function ($event) {
                                              return _vm.view(datascreen.id)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-view",
                                          }),
                                          _vm._v(" 预览"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v("` "),
            ]
          ),
          _c("vxe-pager", {
            attrs: {
              background: "",
              size: "small",
              "current-page": _vm.tablePage.currentPage,
              "page-size": _vm.tablePage.pageSize,
              total: _vm.tablePage.total,
              "page-sizes": [
                10,
                20,
                100,
                1000,
                { label: "全量数据", value: 1000000 },
              ],
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.currentChangeHandle },
          }),
          _c("DataScreenForm", {
            ref: "dataScreenForm",
            on: { refreshDataList: _vm.refreshList },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }